import { getFeatureConfig } from '@luna/feature-config';

export const unsupportedPAPIRequest = (...__: unknown[]) => {
    getFeatureConfig(({ products }) => products.relyOnPAPIEndpointsForData);
    throw new Error('Unsupported PAPI request, waiting on BE implementation');
};
